import { Typography } from '@mui/material';
import { ReactNode } from 'react';
import ButtonComponent from '../FormComponents/Button';
import Modal from '../Modal/Modal';

interface ConfirmationProps {
  text?: string;
  confirm: () => void;
  close: () => void;
  loading?: boolean;
  additionalInfo?: ReactNode;
}

function Confirmation(props: ConfirmationProps) {
  const { text, close, confirm, loading, additionalInfo } = props;

  return (
    <>
      <Modal
        fullWidth
        open={!!text}
        onClose={() => {
          if (loading) {
            return;
          }
          close();
        }}
        title='Confirmation'
        button={<ButtonComponent text='Confirm' onClick={confirm} loading={loading} />}
        data={
          <>
            <Typography>{text}</Typography>
            {additionalInfo}
          </>
        }
      />
    </>
  );
}

export default Confirmation;
